import React, { Component } from 'react';
import Formulario from './VentaEmpleadoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class VentaEmpleado extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, getModulo, listarColaborador, leer,
        limpiarDatos, leerPeriodoD } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        
        getModulo(modulo[5],modulo[4]);
        leerPeriodoD(modulo[5], modulo[7]);
        listarColaborador();
        limpiarDatos();
    }
    
    render(){
        const { loader, modulo, emp, registroVenta, tipo,
            datosColaborador, cargo, lectura, modificarVenta,
            listarProductos, agregarLinea, detallePro, eliminarLinea,
            detalleProducto, agregarLineaProducto, eliminarLineaProducto,
            periodoD } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    emp = {emp}
                    registroVenta = {registroVenta}
                    cargo = {cargo}
                    tipo = {tipo}
                    datosColaborador = {datosColaborador}
                    lectura = {lectura}
                    modificarVenta = {modificarVenta}
                    listarProductos = {listarProductos}
                    agregarLinea = {agregarLinea}
                    detallePro = {detallePro}
                    eliminarLinea = {eliminarLinea}
                    detalleProducto = {detalleProducto}
                    agregarLineaProducto = {agregarLineaProducto}
                    eliminarLineaProducto = {eliminarLineaProducto}
                    periodo={periodoD}
                />
            </LoadMask>
        );
    }
}

export default VentaEmpleado;